module.exports = __webpack_public_path__ + "img/hardwareRouter4.746d7bd6.png";